import { reducerWithInitialState } from "typescript-fsa-reducers";
import { highlightRows, unhighlightRows } from "./actions";

export type HighlightedRowsState = string[];

export default reducerWithInitialState<HighlightedRowsState>([])
  .case(unhighlightRows, _ => [])
  .case(highlightRows, (_, highlightedRows: string[]) => highlightedRows);



// WEBPACK FOOTER //
// ./src/spread/model/highlightedRows/reducer.ts